import React from 'react'
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';

const Sites = () => {
  const {t} = useTranslation();

  return (
      <div className="flex flex-col text-sm font-semibold text-gray-500 dark:text-neutral-300 gap-2 mb-4 lg:mb-0">
        <div className="text-lg text-dark-primary mb-3">Sites</div>
        {/*<Link to="/career">{t("footer.career")}</Link>*/}
        <Link to="/start">Start</Link>
        <Link to="/market">Market</Link>
        <Link to="/database">Database</Link>
      </div>
  );
};
export default Sites
